'use strict';

// import Vue from 'vue';
// import VueRouter from 'vue-router';

var Vue = require('vue');
var VueRouter = require('vue-router');

Vue.use(VueRouter);

var router = new VueRouter({
  // hashbang: true,
  history: true,
  saveScrollPosition: false,
  transitionOnLoad: true,
});

router.map({
  '/': {
    name: 'index',
    component: function (resolve) {
      require([ './components/Hello.vue' ], resolve);
    },
  },
  '/school/:schoolAbbr': {
    name: 'schoolIndex',
    component: function (resolve) {
      require([ './components/Hello.vue' ], resolve);
    },
  },
  '/help': {
    component: function (resolve) {
      require([ './components/Help.vue' ], resolve);
    },
    subRoutes: {
      '/about': {
        name: 'help-about',
        component: function (resolve) {
          require([ './components/HelpAbout.vue' ], resolve);
        },
      },
      '/faq': {
        name: 'help-faq',
        component: function (resolve) {
          require([ './components/HelpFaq.vue' ], resolve);
        },
      },
      '/email': {
        name: 'help-email',
        component: function (resolve) {
          require([ './components/HelpEmail.vue' ], resolve);
        },
      },
      '/business-partnership':{
        name: 'business-partnership',
        component: function (resolve) {
          require([ './components/BusinessPartnership.vue' ], resolve);
        },
      },
      '/contact-us':{
        name: 'contact-us',
        component: function (resolve) {
          require([ './components/ContactUs.vue' ], resolve);
        },
      },
      '/new-hire':{
        name: 'new-hire',
        component: function (resolve) {
          require([ './components/NewHire.vue' ], resolve);
        },
      },
      '/ban': {
        name: 'help-ban',
        component: function (resolve) {
          require([ './components/HelpBan.vue' ], resolve);
        },
      },
    },
  },
  '/search': {
    name: 'search',
    component: function (resolve) {
      require([ './components/Search.vue' ], resolve);
    },
  },
  '/message': {
    name: 'message',
    component: function (resolve) {
      require([ './components/Message.vue' ], resolve);
    },
  },
  '/detail/:iid': {
    name: 'detail',
    component: function (resolve) {
      require([ './components/Detail.vue' ], resolve);
    },
  },
  '/secure': {
    name: 'secure',
    component: function (resolve) {
      require([ './components/Secure.vue' ], resolve);
    },
  },
  '/login': {
    name: 'login',
    component: function (resolve) {
      require([ './components/Login.vue' ], resolve);
    },
  },
  '/signup': {
    name: 'signup',
    component: function (resolve) {
      require([ './components/Signup.vue' ], resolve);
    },
  },
  '/forgetpassword': {
    component: function (resolve) {
      require([ './components/ForgetPassword.vue' ], resolve);
    },
  },
  '/sell': {
    name: 'sell',
    component: function (resolve) {
      require([ './components/Sell.vue' ], resolve);
    },
  },
  '/sell/:iid': {
    name: 'edit',
    component: function (resolve) {
      require([ './components/Sell.vue' ], resolve);
    },
  },
  '/u/:userid': {
    name: 'u',
    component: function (resolve) {
      require([ './components/U.vue' ], resolve);
    },
  },
  '/user': {
    component: function (resolve) {
      require([ './components/User.vue' ], resolve);
    },
    subRoutes: {
      '/': {
        component: function (resolve) {
          require([ './components/UserRedirect.vue' ], resolve);
        },
      },
      '/nav': {
        name: 'user-nav',
        component: function (resolve) {
          require([ './components/UserNav.vue' ], resolve);
        },
      },
      '/like': {
        component: function (resolve) {
          require([ './components/UserLike.vue' ], resolve);
        },
      },
      '/manage': {
        name: 'user-manage',
        component: function (resolve) {
          require([ './components/UserManage.vue' ], resolve);
        },
      },
      '/profile': {
        name: 'user-profile',
        component: function (resolve) {
          require([ './components/UserProfile.vue' ], resolve);
        },
      },
      '/forum': {
        name: 'user-forum',
        component: function (resolve) {
          require([ './components/UserForum.vue' ], resolve);
        },
      },
      '/password': {
        component: function (resolve) {
          require([ './components/UserPassword.vue' ], resolve);
        },
      },
      '/logout': {
        component: function (resolve) {
          require([ './components/UserLogout.vue' ], resolve);
        },
      },
    },
  },
  '/forum': {
    name: 'forum',
    component: Vue.extend({
      watch: {
        '$route': {
          deep: true,
          handler (to) {
            if (to.name !== 'forum') return;
            this.redirect();
          },
        },
      },
      methods: {
        redirect () {
          router.go({ name: 'forum-list', params: { forumId: 'default' } });
        },
      },
      attached () {
        this.redirect();
      },
    }),
  },
  '/forum/list/:forumId': {
    name: 'forum-list',
    component: function (resolve) {
      require([ './components/Forum.vue' ], resolve);
    },
  },
  '/forum/topic/:ftid': {
    name: 'forum-topic',
    component: function (resolve) {
      require([ './components/ForumTopic.vue' ], resolve);
    },
  },
  '/ad/statefarm': {
    name: 'ad-statefarm',
    component: function (resolve) {
      require([ './components/ad/StateFarm.vue' ], resolve);
    },
  },
  '*': {
    component: function (resolve) {
      require([ './components/JumpToSchool.vue' ], resolve);
    },
  },
  '/not-found': {
    name: 'not-found',
    component: function (resolve) {
      require([ './components/NotFound.vue' ], resolve);
    },
  },
});

router.beforeEach(function () {
  window.scrollTo(0, 0);
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js